import { render, staticRenderFns } from "./BaseDir.vue?vue&type=template&id=1aaf1c48&scoped=true&lang=pug&"
import script from "./BaseDir.vue?vue&type=script&lang=js&"
export * from "./BaseDir.vue?vue&type=script&lang=js&"
import style0 from "./BaseDir.vue?vue&type=style&index=0&id=1aaf1c48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aaf1c48",
  null
  
)

export default component.exports